module.exports = {
  email: "me@awixor.com",

  socialMedia: [
    {
      name: "GitHub",
      url: "https://github.com/awixor",
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/awixor",
    },
    {
      name: "Twitter",
      url: "https://twitter.com/HAoussare",
    },
    {
      name: "Linkedin",
      url: "https://www.linkedin.com/in/awixor",
    },
    {
      name: "Behance",
      url: "https://www.behance.net/awixor",
    },
  ],

  navLinks: [
    {
      name: "About",
      url: "/#about",
    },
    {
      name: "Experience",
      url: "/#skills",
    },
    {
      name: "Work",
      url: "/#projects",
    },
    {
      name: "Contact",
      url: "/#contact",
    },
  ],

  colors: {
    red: "#E52E2D",
    navy: "#2B2A2A",
    darkNavy: "#212121",
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: "bottom",
    distance: "20px",
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: "cubic-bezier(0.645, 0.045, 0.355, 1)",
    mobile: true,
    reset: false,
    useDelay: "always",
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
}
